/* eslint-disable */
import { createAPI } from '../util';
// mock server: 'http://easy-mock.gm/mock/5d26995dee38780b47362c02/login'
const baseUrl = 'https://www.djc123.com/djc-gateway';
export default createAPI(baseUrl);
